/** Small inline icons for the custom pieces (post cards, menus, steps). Polaris components use `s-icon`. */
const PATHS = {
  check: 'M5 12.5l4.5 4.5L19 7.5',
  close: 'M6 6l12 12M18 6L6 18',
  text: 'M5 6h14M5 12h14M5 18h9',
  instagram: 'M7 3h10a4 4 0 014 4v10a4 4 0 01-4 4H7a4 4 0 01-4-4V7a4 4 0 014-4zM12 16a4 4 0 100-8 4 4 0 000 8zM17.5 6.5h.01',
  search: 'M11 18a7 7 0 100-14 7 7 0 000 14zM20 20l-4-4',
  lock: 'M7 11V8a5 5 0 0110 0v3M6 11h12v9H6z',
  hide: 'M3 3l18 18M10.6 10.6a2 2 0 002.8 2.8M9.9 5.1A9.7 9.7 0 0112 5c5 0 9 5 9 7a10.5 10.5 0 01-2.6 3.5M6.6 6.6C4.4 8 3 10.4 3 12c0 2 4 7 9 7a9.6 9.6 0 004.2-.9',
  view: 'M3 12c0-2 4-7 9-7s9 5 9 7-4 7-9 7-9-5-9-7zm9 3a3 3 0 100-6 3 3 0 000 6z',
  pin: 'M9 3h6l-1 6 4 4H6l4-4zM12 13v8',
  dots: 'M6 12h.01M12 12h.01M18 12h.01',
  image: 'M4 5h16v14H4zM4 16l5-5 4 4 2-2 5 5M15 9h.01',
  external: 'M14 4h6v6M20 4l-9 9M18 14v6H4V6h6',
  up: 'M12 19V5M6 11l6-6 6 6',
  down: 'M12 5v14M6 13l6 6 6-6',
  tag: 'M3 12V4h8l9 9-8 8zM7.5 7.5h.01',
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({ name }: { name: IconName }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d={PATHS[name]} />
    </svg>
  );
}

export const KIND_MARK = { video: 'M8 5v14l11-7z', reel: 'M8 5v14l11-7z', carousel: 'M4 8h12v12H4zM8 4h12v12h-2V6H8z' } as const;
